// confirmFields.js

export const basicInfoFields = [
  { key: 'name', label: '氏名', required: true },
  { key: 'furigana', label: 'フリガナ', required: true },
  { key: 'birthdate', label: '生年月日', required: true },
  { key: 'postal_code', label: '郵便番号（住民票）', required: true },
  { key: 'address_resident', label: '住所（住民票）', required: true },
  { key: 'postal_code_post', label: '郵便番号（郵送先）', required: false },
  { key: 'address_post', label: '住所（郵送先）', required: false },
  { key: 'nearest_station', label: '最寄駅', required: true },
  { key: 'phone', label: '電話番号', required: true },
  { key: 'blood_type', label: '血液型', required: true },
  { key: 'bank_name', label: '銀行名', required: true },
  { key: 'branch_name', label: '支店名', required: true },
  { key: 'account_type', label: '口座種別', required: true },
  { key: 'account_number', label: '口座番号', required: true },
];

export const emergencyFields = [
  { key: 'emergency_name', label: '氏名', required: true },
  { key: 'emergency_furigana', label: 'フリガナ', required: true },
  { key: 'emergency_relationship', label: '続柄', required: true },
  { key: 'emergency_phone', label: '電話番号', required: true },
];

export const familyFields = [
  { key: 'name', label: '氏名', required: true },
  { key: 'furigana', label: 'フリガナ', required: true },
  { key: 'birthdate', label: '生年月日', required: true },
  { key: 'relationship', label: '続柄', required: true },
  { key: 'cohabitation', label: '同居', required: true },
  { key: 'occupation', label: '職業', required: true },
  { key: 'income_range', label: '年収区分', required: false },
];
